export interface Menu {
  id: number;
  name: string;
  isActive: boolean;
  createdAt: Date;
  updatedAt: Date;
}

export const getEmptyMenu = (): Menu => ({
  id: 0,
  name: '',
  isActive: false,
  createdAt: new Date(),
  updatedAt: new Date(),
});

export const menuFromResponse = (responseData: any): Menu => ({
  id: responseData.id,
  name: responseData.name,
  isActive: responseData.is_active,
  createdAt: new Date(responseData.created_at),
  updatedAt: new Date(responseData.updated_at),
});

export const menuToUpsertRequest = (menu: Menu) => ({
  name: menu.name,
  is_active: menu.isActive,
});
